import { useEffect, useState } from "react";
const useIsMobileDetect = () => {
    const [isMobilePortrait, setIsMobilePortrait] = useState(false);
    useEffect(() => {
        if (typeof window === "undefined")
            return;
        const query = "(orientation: landscape) and (max-height: 600px)";
        const mediaQuery = window.matchMedia(query);
        const updateMatch = (e) => {
            setIsMobilePortrait(e.matches);
        };
        updateMatch(mediaQuery);
        const handler = (e) => updateMatch(e);
        mediaQuery.addEventListener("change", handler);
        return () => mediaQuery.removeEventListener("change", handler);
    }, []);
    return isMobilePortrait;
};
export default useIsMobileDetect;
